import { Button, Flex } from '@chakra-ui/react';
import { CheckoutButtonProps } from '../types';

/**
 * Checkout button component
 * Handles the main call-to-action for proceeding to checkout
 */
const CheckoutButton = ({ onCheckout }: CheckoutButtonProps): JSX.Element => (
  <Flex>
    <Button
      aria-label="Go to checkout"
      flexGrow={1}
      onClick={onCheckout}
      colorScheme="yellow"
    >
      Go to checkout
    </Button>
  </Flex>
);

export default CheckoutButton;
